import React from "react";
import "./index.css";
import { useConfig } from "../../contexts/config";
import { useTheme } from "../../contexts/ThemeContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Import images from assets
import foto1 from "./assets/foto1.jpg";
import foto2 from "./assets/foto2.jpg";
import foto3 from "./assets/foto3.jpg";

const getBannerColors = (imageUrl) => {
  if (imageUrl && typeof imageUrl === 'string') {
    if (imageUrl.includes('foto1')) {
      return {
        "--wedge-dominant": "rgba(195, 254, 114, 0.7)",
        "--wedge-accent": "rgba(35, 223, 10, 0.7)",
        "--wedge-text-color": "#235a06",
        "--wedge-btn-text-color": "#235a06",
        "--wedge-label-bg-color": "#235a06",
      };
    }
    if (imageUrl.includes('foto2')) {
      return {
        "--wedge-dominant": "rgba(0, 147, 216, 0.7)",
        "--wedge-accent": "rgba(15, 40, 68, 0.7)",
        "--wedge-text-color": "#ffffff",
        "--wedge-btn-text-color": "#005a8b",
      };
    }
    if (imageUrl.includes('foto3')) {
      return {
        "--wedge-dominant": "rgba(209, 40, 150, 0.7)",
        "--wedge-accent": "rgba(160, 10, 223, 0.6)",
        "--wedge-text-color": "#ffffff",
        "--wedge-btn-text-color": "#d12896",
      };
    }
  }
  return {
    "--wedge-dominant": "rgba(0, 147, 216, 0.7)",
    "--wedge-accent": "rgba(15, 40, 68, 0.7)",
    "--wedge-text-color": "#ffffff",
    "--wedge-btn-text-color": "#0093d8",
  };
};

export const HeaderCourses = ({ moodle, lang }) => {
  const theme = useTheme();

  const banners = [
    {
      id: 1,
      image: foto1,
      label: "PROGRAMA 2024",
      title: "Conoce",
      subtitle: <>nuestro pack de apoyo a la <strong>Convivencia Escolar</strong>.</>,
      buttonText: "Ver más",
      link: "https://www.decididoeducacion.cl/",
      showArrow: true,
      bgPosition: "center center"
    },
    {
      id: 2,
      image: foto2,
      title: "Formación",
      subtitle: <> de <strong>Excelencia</strong> para potenciar el aprendizaje continúo.</>,
      buttonText: "Ver más",
      link: "https://decididocapacita.cl/",
      bgPosition: "center center"
    },
    {
      id: 3,
      image: foto3,
      title: "La Familia",
      subtitle: <>y la <strong>Educación</strong> con herramientas prácticas y efectivas <br />para el desarrollo integral de las nuevas generaciones.</>,
      buttonText: "VER MÁS",
      link: "https://www.serviciosdecidido.cl/",
      bgPosition: "right top"
    },
  ];

  return (
    <>
      {lang && (
        <div style={{ paddingTop: "80px" }} className="header-carousel-container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            navigation={false}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            className="header-carousel"
          >
            {banners.map((banner) => (
              <SwiperSlide key={banner.id}>
                <div
                  className="header-banner"
                  style={{
                    backgroundImage: `url(${banner.image})`,
                    backgroundPosition: banner.bgPosition || "center center"
                  }}
                >
                  <div className="wedge-overlay" style={getBannerColors(banner.image)}>
                    <div className="wedge-content">
                      {banner.label && (
                        <span className="wedge-label">{banner.label}</span>
                      )}
                      <h1 className="wedge-title font-jost">
                        {banner.title}
                      </h1>
                      <p className="wedge-subtitle">
                        {banner.subtitle}
                      </p>
                      <a
                        href={banner.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="wedge-btn"
                      >
                        {banner.buttonText}
                        {banner.showArrow && <span className="wedge-btn-arrow"> →</span>}
                      </a>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};


